import { Container, Row, Col } from 'react-bootstrap';
import PlanCard from './PlanCard';

const cardData = {
  planName: 'Final Average Pay Plan',
  planDate: 'As of May 20, 2022',
  status: 'Active',
  vestingPercentage: 100,
  services: {
    hireDate: 'Nov 13, 1999',
    participationDate: 'Nov 1, 2013',
    totalVestingService: '21.083 years',
    creditedServices: '7.167 years',
  },

  keyDates: {
    fullyVestedDate: '-',
    earlyRetirementDate: 'July 1, 2022',
    normalRetirementDate: 'July 1, 2034',
  },
};

const PlanCardDemo = () => {
  return (
    <Container>
      <h4>Plan Card</h4>
      <Row className={'flex-column flex-lg-row flex-wrap'}>
        <Col className={'col-12 col-lg-4'}>
          <PlanCard cardData={cardData} />
        </Col>
        <Col className={'col-12 col-lg-4'}>
          <PlanCard cardData={cardData} />
        </Col>
        <Col className={'col-12 col-lg-4'}>
          <PlanCard cardData={cardData} />
        </Col>
      </Row>
    </Container>
  );
};

export default PlanCardDemo;
